export default {
    methods: {
        async openDatabase() {
            return new Promise((resolve, reject) => {
                const request = indexedDB.open('imagesDB', 1);
                request.onupgradeneeded = function (event) {
                    const db = event.target.result;
                    if (!db.objectStoreNames.contains('images')) {
                        db.createObjectStore('images', {keyPath: 'id', autoIncrement: true});
                    }
                };
                request.onsuccess = function (event) {
                    resolve(event.target.result);
                };
                request.onerror = function (event) {
                    reject('Erro ao abrir o IndexedDB:', event);
                };
            });
        },
        async clearDatabase() {
            const db = await this.openDatabase();
            return new Promise((resolve, reject) => {
                const transaction = db.transaction(['images'], 'readwrite');
                const store = transaction.objectStore('images');
                const clearRequest = store.clear();
                clearRequest.onsuccess = function () {
                    resolve(true);
                };
                clearRequest.onerror = function () {
                    reject('Erro ao limpar o IndexedDB');
                };
            });
        },
        async saveImageToIndexedDB(imageData) {
            const db = await this.openDatabase();
            await this.clearDatabase();
            return new Promise((resolve, reject) => {
                const transaction = db.transaction(['images'], 'readwrite');
                const store = transaction.objectStore('images');
                const request = store.add(imageData);
                request.onsuccess = function () {
                    resolve(true);
                };
                request.onerror = function () {
                    reject('Erro ao salvar a imagem no IndexedDB');
                };
            });
        },
        async getImagesFromIndexedDB() {
            const db = await this.openDatabase();
            return new Promise((resolve, reject) => {
                const transaction = db.transaction(['images'], 'readonly');
                const store = transaction.objectStore('images');
                const request = store.getAll();
                request.onsuccess = function (event) {
                    resolve(event.target.result);
                };
                request.onerror = function () {
                    reject('Erro ao recuperar imagens do IndexedDB');
                };
            });
        }

    }
}
